import React, { useEffect, useMemo } from "react";
import { useLiff } from "react-liff";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();
  const { liff } = useLiff();
  const lineId = useMemo(() => {
    try {
      return liff?.getDecodedIDToken()?.sub || "";
    } catch (error) {
      return "";
    }
  }, [liff]);

  useEffect(() => {
    if (lineId) {
      navigate("/register");
    }
  }, [lineId, navigate]);

  return (
    <>
      <div>isLoggedIn</div>
      <div>sub {lineId}</div>
    </>
  );
}
